// @flow

import * as React from "react";
import Iframe from "react-iframe";

import "./PDF.css";

type PDFProps = {
  url: string,
  width: string,
  height: string
};

const PDF = (props: PDFProps) => (
  <div className="PDF">
    <Iframe
      url={props.url}
      width={props.width}
      height={props.height}
      className="PDF-IFrame"
      display="block"
      position="relative"
    />
  </div>
);

export default PDF;



// WEBPACK FOOTER //
// ./src/components/PDF/PDF.js